import Body from './Body';
export default (props) => {
  return <Body {...props} />;
};
